<div class="card card-nc esign_box">
  <div class="container">
    <div class="col-12">
      <div style="width: 80%; margin: 0 auto;">
        <app-progress-bar
          [whichStep]="4"
          [sectionsArray]="tabs"
        ></app-progress-bar>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>PRIVACY ACT STATEMENT:</b><br />
            <b>AUTHORITY: </b>
            P.L. 104-134, Debt Collection Improvement Act 1996, as amended; 5
            U.S.C. 5514; 31 U.S.C. Sections 1322 and 3720A; 37 U.S.C. Section
            1007; 31 CFR 210 and 285; and E.O. 9397<br />
            <b>PRINCIPAL PURPOSE(S): </b>
            To enroll individuals in the Treasury SVC program; to obtain
            authorization to initiate debit and credit entries to individual's
            accounts; and to facilitate collection of any delinquent amounts.<br />
            <b>ROUTINE USE(S): </b>
            The information on this form may be disclosed as generally permitted
            under 5 U.S.C. Section 522a(b) of the Privacy Act of 1974, as
            amended. It may be disclosed outside of the U.S. Department of the
            Treasury to its Fiscal and Financial Agents and their contractors
            involved in providing SVC services, or to the Department of Defense
            (DoD) for the purpose of administering the Treasury SVC programs. In
            addition, other Federal, State, or local government agencies that
            have identified a need to know may obtain this information for the
            purpose(s) as identified by the Bureau of the Fiscal Service (Fiscal
            Service) Routine Uses as published in the Federal Register.<br />
            <b>DISCLOSURE: </b>
            Disclosure is voluntary; however, failure to furnish requested
            information may significantly delay or prevent your participation in
            the Treasury SVC program.<br />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>BURDEN ESTIMATE STATEMENT: OMB No. 1530-0013</b><br />
            According to the Paperwork Reduction Act of 1995, no persons are
            required to respond to a collection of information unless it
            displays a valid OMB control number. The time required to complete
            this information collection is estimated to average 10 minutes,
            including the time to review instructions, search existing data
            sources, gather and maintain the data needed, and complete and
            review the collection of information. Comments concerning the
            accuracy of the time estimate and suggestions for reducing this
            burden should be directed to the U.S. Department of the Treasury,
            Bureau of the Fiscal Service, 401 14th Street SW, Washington DC
            20227.<br />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>APPLICANT PERSONAL INFORMATION:</b><br />
            <form
              id="personalForm"
              name="personalForm"
              class="form-horizontal"
              [formGroup]="personalForm"
            >
              <div class="row">
                <div class="col-md-2 zeroPadding">
                  <label
                    for="title"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Rate, Rank, Title
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="title"
                      formControlName="title"
                      name="title"
                      maxlength="15"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('title').valid &&
                        personalForm.get('title').touched &&
                        personalForm.get('title').errors['invalidName']
                      "
                    >
                      Only alphabet, numbers and spaces are allowed- no special
                      characters
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="firstName"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *First Name
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="firstName"
                      formControlName="firstName"
                      name="firstName"
                      maxlength="30"
                    />
                    <span *ngIf="!personalForm.get('firstName').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('firstName').valid &&
                          personalForm.get('firstName').touched &&
                          personalForm.get('firstName').errors['maxLength']
                        "
                      >
                        Name too long
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('firstName').valid &&
                          personalForm.get('firstName').touched &&
                          personalForm.get('firstName').errors['required']
                        "
                      >
                        Required
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('firstName').valid &&
                          personalForm.get('firstName').touched &&
                          personalForm.get('firstName').errors['invalidName']
                        "
                      >
                        Only alphabets, space and - are allowed
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="middleInitial"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Middle Initial
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="middleInitial"
                      formControlName="middleInitial"
                      name="middleInitial"
                      maxlength="1"
                    />
                    <span *ngIf="!personalForm.get('middleInitial').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('middleInitial').valid &&
                          personalForm.get('middleInitial').touched &&
                          personalForm.get('middleInitial').errors[
                            'invalidMiddleName'
                          ]
                        "
                      >
                        Only alphabet characters are allowed
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-5 zeroPadding">
                  <label
                    for="lastName"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Last Name
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="lastName"
                      formControlName="lastName"
                      name="lastName"
                      maxlength="30"
                    />
                    <span *ngIf="!personalForm.get('lastName').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('lastName').valid &&
                          personalForm.get('lastName').touched &&
                          personalForm.get('lastName').errors['maxLength']
                        "
                      >
                        Name too long
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('lastName').valid &&
                          personalForm.get('lastName').touched &&
                          personalForm.get('lastName').errors['required']
                        "
                      >
                        Required
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('lastName').valid &&
                          personalForm.get('lastName').touched &&
                          personalForm.get('lastName').errors['invalidName']
                        "
                      >
                        Only alphabets, space and - are allowed
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 zeroPadding">
                  <label
                    for="payGrade"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Pay Grade
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="payGrade"
                      formControlName="payGrade"
                    >
                      <option value="" disabled="disabled" selected>
                        Please Select...
                      </option>
                      <option *ngFor="let rank of ranks" [ngValue]="rank">
                        {{ rank }}
                      </option>
                    </select>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('payGrade').valid &&
                        personalForm.get('payGrade').touched &&
                        personalForm.get('payGrade').errors['required']
                      "
                    >
                      Required
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="branch"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Military Branch
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="branch"
                      formControlName="branch"
                    >
                      <option value="" disabled="disabled" selected>
                         Please Select...
                      </option>
                      <option *ngFor="let branch of branchs" [ngValue]="branch">
                        {{ branch }}
                      </option>
                    </select>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('branch').valid &&
                        personalForm.get('branch').touched &&
                        personalForm.get('branch').errors['required']
                      "
                    >
                      Required
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label for="ssn" class="col-md-12 control-label enrollLabel">
                    *SSN
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="ssn"
                      formControlName="ssn"
                      name="ssn"
                      maxlength="9"
                    />
                    <span *ngIf="!personalForm.get('ssn').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('ssn').valid &&
                          personalForm.get('ssn').touched &&
                          personalForm.get('ssn').errors['invalidSoc']
                        "
                      >
                        Only 9 numbers allowed- no spaces or dashes
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('ssn').valid &&
                          personalForm.get('ssn').touched &&
                          personalForm.get('ssn').errors['required']
                        "
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label for="dob" class="col-md-12 control-label enrollLabel">
                    *Date of Birth
                  </label>
                  <div class="col-xs-12 col-md-12">
                    <div class="input-group datepicker dtpicker-btn">
                      <input
                        id="dob"
                        class="form-control"
                        formControlName="dob"
                        (dateSelect)="changeDate($event)"
                        placeholder="(MM/DD/YYYY)"
                        (select)="changeDate($event)"
                        (change)="changeDate($event)"
                        ngbDatepicker
                        #d2="ngbDatepicker"
                        readonly
                      />
                      <div class="input-group-append">
                        <button
                          class="fa fa-calendar"
                          (click)="d2.toggle()"
                          type="button"
                        ></button>
                      </div>
                    </div>
                    <span *ngIf="!personalForm.get('dob').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('dob').valid &&
                          personalForm.get('dob').touched &&
                          personalForm.get('dob').errors['required']
                        "
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-3 zeroPadding">
                  <label
                    for="maiden"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Mother's Maiden Name
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="mainden"
                      formControlName="maiden"
                      name="maiden"
                      maxlength="30"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('maiden').valid &&
                        personalForm.get('maiden').touched &&
                        personalForm.get('maiden').errors['maxlength']
                      "
                    >
                      Name too long
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('maiden').valid &&
                        personalForm.get('maiden').touched &&
                        personalForm.get('maiden').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('maiden').valid &&
                        personalForm.get('maiden').touched &&
                        personalForm.get('maiden').errors['invalidName']
                      "
                    >
                      Only alphabets, space and - are allowed
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 zeroPadding">
                  <label
                    for="company"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Company Name (If Contractor)
                  </label>
                  <div class="form-group col-md-11">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="company"
                      formControlName="company"
                      name="company"
                      maxlength="30"
                    />
                  </div>
                </div>
                <div
                class="col-md-2 zeroPadding"
                *ngIf="locations !== undefined"
                >
                <label
                  for="location"
                  class="col-md-12 control-label enrollLabel"
                >
                  *Card Pickup Location
                </label>
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-sm"
                    id="location"
                    formControlName="location"
                  >
                    <option value="" disabled="disabled" selected>
                         Please Select...
                    </option>
                    <option
                      *ngFor="let loc of locations | sort: 'shipName'"
                      [ngValue]="loc.shipLocation"
                    >
                      {{ loc.shipName }}
                    </option>
                  </select>
                  <span
                    class="help-block has-error validationMessage"
                    *ngIf="
                      !personalForm.get('location').valid &&
                      personalForm.get('location').touched &&
                      personalForm.get('location').errors['required']
                    "
                  >
                    Required
                  </span>
                </div>
              </div>
                <div *ngIf="personalForm.value.branch == 'Marines' && isCampSelected" class="col-md-2 zeroPadding">
                  <label
                    for="meu"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *MEU
                  </label>
                  <div class="form-group col-md-12">
                    <select
                    class="form-control input-sm"
                    id="meu"
                    formControlName="meu"
                    >
                    <option
                      [disabled]="true"
                      [hidden]="true"
                      [selected]="true"
                      [ngValue]=""
                      >Please Select...</option
                    >
                    <option
                      *ngFor="let meu of applicableMeus"

                    >
                      {{ meu }}
                    </option>
                  </select>
                    <span
                    class="help-block has-error validationMessage"
                    *ngIf="
                      !personalForm.get('meu').valid &&
                      personalForm.get('meu').touched &&
                      (personalForm.get('meu').errors['required'] ||
                      personalForm.get('meu').errors['invalidMeu'])

                    "
                  >
                    Required
                  </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-11 zeroPadding">
                  <label
                    for="permAddress"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Residence/Permanent Address (Not military duty address)
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="permAddressLine1"
                      formControlName="permAddressLine1"
                      name="permAddressLine1"
                      maxlength="34"
                    />
                    <span *ngIf="!personalForm.get('permAddressLine1').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permAddressLine1').valid &&
                          personalForm.get('permAddressLine1').touched &&
                          personalForm.get('permAddressLine1').errors['required']
                        "
                      >
                        Required
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permAddressLine1').valid &&
                          personalForm.get('permAddressLine1').touched &&
                          personalForm.get('permAddressLine1').errors[
                            'invalidAddress'
                          ]
                        "
                      >
                        Enter a valid address
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-11 zeroPadding">
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="permAddressLine2"
                      formControlName="permAddressLine2"
                      name="permAddressLine2"
                      maxlength="34"
                    />
                  </div>
                </div>
                <div class="col-md-11 zeroPadding">
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="permAddressLine3"
                      formControlName="permAddressLine3"
                      name="permAddressLine3"
                      maxlength="34"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 zeroPadding">
                  <label
                    for="permCity"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *City
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="permCity"
                      formControlName="permCity"
                      name="permCity"
                      maxlength="34"
                    />
                    <span *ngIf="!personalForm.get('permCity').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permCity').valid &&
                          personalForm.get('permCity').touched &&
                          personalForm.get('permCity').errors['required']
                        "
                      >
                        Required
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permCity').valid &&
                          personalForm.get('permCity').touched &&
                          personalForm.get('permCity').errors['invalidCity']
                        "
                      >
                        Please enter a valid city name
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="permState"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *State
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="permState"
                      formControlName="permState"
                    >
                      <option value="" disabled="disabled" hidden selected>
                        Please Select...
                      </option>
                      <option *ngFor="let state of states" [value]="state">
                        {{ state }}
                      </option>
                    </select>
                    <span *ngIf="!personalForm.get('permState').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permState').valid &&
                          personalForm.get('permState').touched &&
                          personalForm.get('permState').errors['required']
                        "
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="permZip"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *ZIP Code
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="permZip"
                      formControlName="permZip"
                      name="permZip"
                      maxlength="10"
                    />
                    <span *ngIf="!personalForm.get('permZip').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('permZip').valid &&
                          personalForm.get('permZip').touched
                        "
                      >
                        <span
                          *ngIf="personalForm.get('permZip').errors['invalidZip']"
                        >
                          {{ contactZipErrorMessage }}
                        </span>
                        <span
                          *ngIf="personalForm.get('permZip').errors?.required"
                        >
                          Required
                        </span>
                        <span
                          *ngIf="personalForm.get('permZip').errors?.maxlength"
                        >
                          Zip can only be 10 characters
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="permCountry"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Country
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="permCountry"
                      formControlName="permCountry"
                    >
                      <option value="" disabled="disabled"  hidden selected>
                        Please Select...
                      </option>
                      <option
                        *ngFor="let country of countries"
                        [value]="country"
                      >
                        {{ country }}
                      </option>
                    </select>
                    <span
                      *ngIf="personalForm.get('permCountry').errors?.required"
                    >
                          Required
                        </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-11 zeroPadding">
                  <label
                    for="addressLine1"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Military Duty Address
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="addressLine1"
                      formControlName="addressLine1"
                      name="addressLine1"
                      maxlength="34"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('addressLine1').valid &&
                        personalForm.get('addressLine1').touched &&
                        personalForm.get('addressLine1').errors[
                          'invalidAddress'
                        ]
                      "
                    >
                      Enter a valid address
                    </span>
                  </div>
                </div>
                <div class="col-md-11 zeroPadding">
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="addressLine2"
                      formControlName="addressLine2"
                      name="addressLine2"
                      maxlength="34"
                    />
                  </div>
                </div>
                <div class="col-md-11 zeroPadding">
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="addressLine3"
                      formControlName="addressLine3"
                      name="addressLine3"
                      maxlength="34"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 zeroPadding">
                  <label for="city" class="col-md-12 control-label enrollLabel">
                    City
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="city"
                      formControlName="city"
                      name="city"
                      maxlength="34"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('city').valid &&
                        personalForm.get('city').touched &&
                        personalForm.get('city').errors['invalidName']
                      "
                    >
                      Please enter a valid city name
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="state"
                    class="col-md-12 control-label enrollLabel"
                  >
                    State
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="state"
                      formControlName="state"
                    >
                      <option value="" disabled="disabled" hidden selected>
                        Please Select...
                      </option>
                      <option *ngFor="let state of states" [value]="state">
                        {{ state }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label for="zip" class="col-md-12 control-label enrollLabel">
                    ZIP Code
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="zip"
                      formControlName="zip"
                      name="zip"
                      maxlength="10"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !personalForm.get('zip').valid &&
                        personalForm.get('zip').touched
                      "
                    >
                      <span
                        *ngIf="personalForm.get('zip').errors['invalidZip']"
                      >
                        {{ contactZipErrorMessage }}
                      </span>
                      <span *ngIf="personalForm.get('zip').errors?.required">
                        Required
                      </span>
                      <span *ngIf="personalForm.get('zip').errors?.maxlength">
                        Zip can only be 10 characters
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="country"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Country
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="country"
                      formControlName="country"
                    >
                      <option value="" disabled="disabled" hidden selected>
                        Please Select...
                      </option>
                      <option
                        *ngFor="let country of countries"
                        [value]="country"
                      >
                        {{ country }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 zeroPadding">
                  <label
                    for="phone"
                    class="col-md-12 control-label enrollLabel"
                  >
                    *Phone
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="phone"
                      formControlName="phone"
                      name="phone"
                      maxlength="14"
                    />
                    <span *ngIf="!personalForm.get('phone').disabled" >
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('phone').valid &&
                          personalForm.get('phone').touched &&
                          personalForm.get('phone').errors['required']
                        "
                      >
                        Required
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          !personalForm.get('phone').valid &&
                          personalForm.get('phone').touched &&
                          personalForm.get('phone').errors['invalidPhone']
                        "
                      >
                        Numbers only allowed
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="font-size: 14px;">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>APPLICANT BANK OR CREDIT UNION INFORMATION:</b><br />
            <form
              id="bankForm"
              name="bankForm"
              class="form-horizontal"
              [formGroup]="bankForm"
            >
              <div class="row">
                <div class="col-md-3 zeroPadding">
                  <label
                    for="bankName"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Bank or Credit Union Name
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="bankName"
                      formControlName="bankName"
                      name="bankName"
                      maxlength="30"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('bankName').valid &&
                        bankForm.get('bankName').touched &&
                        bankForm.get('bankName').errors['maxlength']
                      "
                    >
                      Name too long
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('bankName').valid &&
                        bankForm.get('bankName').touched &&
                        bankForm.get('bankName').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('bankName').valid &&
                        bankForm.get('bankName').touched &&
                        bankForm.get('bankName').errors['invalidAddress']
                      "
                    >
                      Only alphabets, space and - are allowed
                    </span>
                  </div>
                </div>
                <div class="col-md-3 zeroPadding">
                  <label
                    for="acctName"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Name on Account
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="acctName"
                      formControlName="acctName"
                      name="acctName"
                      maxlength="22"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('acctName').valid &&
                        bankForm.get('acctName').touched &&
                        bankForm.get('acctName').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('acctName').valid &&
                        bankForm.get('acctName').touched &&
                        bankForm.get('acctName').errors['invalidAddress']
                      "
                    >
                      Only alphabets, space and - are allowed
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 zeroPadding">
                  <label
                    for="routing"
                    class="col-md-12 control-label enrollLabel"
                  >
                    ABA Routing Number (9-digits)
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="routing"
                      formControlName="routing"
                      name="routing"
                      maxlength="9"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('routing').valid &&
                        bankForm.get('routing').touched &&
                        bankForm.get('routing').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('routing').valid &&
                        bankForm.get('routing').touched &&
                        bankForm.get('routing').errors['invalidRoutingNumber']
                      "
                    >
                      Invalid ABA Routing Number
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="acctNumber"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Account Number
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="acctNumber"
                      formControlName="acctNumber"
                      name="acctNumber"
                      maxlength="16"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('acctNumber').valid &&
                        bankForm.get('acctNumber').touched &&
                        bankForm.get('acctNumber').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('acctNumber').valid &&
                        bankForm.get('acctNumber').touched &&
                        bankForm.get('acctNumber').errors['invalidSrcAcctNum']
                      "
                    >
                      Invalid Account Number
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="confirmAcctNumber"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Confirm Account Number
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="confirmAcctNumber"
                      formControlName="confirmAcctNumber"
                      name="confirmAcctNumber"
                      maxlength="16"
                    />
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('confirmAcctNumber').valid &&
                        bankForm.get('confirmAcctNumber').touched &&
                        bankForm.get('confirmAcctNumber').errors['required']
                      "
                    >
                      Required
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('confirmAcctNumber').valid &&
                        bankForm.get('confirmAcctNumber').touched &&
                        bankForm.get('confirmAcctNumber').errors['matchError']
                      "
                    >
                      Account Numbers do not match
                    </span>
                  </div>
                </div>
                <div class="col-md-2 zeroPadding">
                  <label
                    for="acctType"
                    class="col-md-12 control-label enrollLabel"
                  >
                    Account Type
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      class="form-control input-sm"
                      id="acctType"
                      formControlName="acctType"
                    >
                      <option value="" disabled="disabled" selected>Please Select...</option>
                      <option *ngFor="let type of acctTypes" [ngValue]="type">
                        {{ type }}
                      </option>
                    </select>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        !bankForm.get('acctType').valid &&
                        bankForm.get('acctType').touched &&
                        bankForm.get('acctType').errors['required']
                      "
                    >
                      Required
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>STATEMENT OF UNDERSTANDING:</b><br />
            <b>DEBT COLLECTION/WAIVER OF PRIOR USE PROCESS: </b>
            In consideration of receiving a Treasury SVC, I hereby knowingly and
            voluntarily consent to the immediate collection from my U.S.
            Government pay (military or civilian), without prior notice or prior
            opportunity for a hearing or review, of any amounts that may become
            due and owing as a result of my use of the Treasury SVC. This means
            the government may deduct amounts owed from my pay as authorized by
            5 U.S.C. 5514, 37 U.S.C. 1007, and other applicable laws. If I am
            employed by a contractor or I am no longer receiving U.S. Government
            military or civilian pay and amounts remain or become due or owing,
            I understand that the government will initiate debt collection
            procedures in accordance with the Federal Claims Collections
            Standards (31 CFR 900-904) and Chapters 28-32, Volume 5, DoD
            7000-14-R, DoD Financial Management Regulation.<br />
            <b>EXPIRED, LOST, STOLEN, OR DAMAGED CARD: </b>
            When my Treasury SVC expires, any value remaining may be forwarded
            to my bank or credit union account specified above. If the account
            has been closed or if any value remaining on the Treasury SVC cannot
            be forwarded to the account for any other reason, I understand that
            the funds may be transferred to an account in the U.S. Treasury in
            accordance with 31 U.S.C. 1322 or elsewhere in accordance with
            applicable law and that I retain the right to claim such funds. If
            my Treasury SVC is lost, stolen, or damaged, I may be charged a fee
            for a replacement card.<br />
            <b>ADDITIONAL TERMS AND CONDITIONS: </b>
            By using the Treasury SVC, I agree to accept the terms and
            conditions for use of the Treasury SVC established bu the issuer of
            the card. This form may be imaged and kept on file electronically by
            the U.S. Department of the Treasury and/or its Financial or Fiscal
            Agent. The electronic image shall be considered the legal equivalent
            of the original.<br />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b
              >AUTHORIZATION TO MAKE SVC TRANSFER ELECTRONICALLY TO AND FROM MY
              BANK OR CREDIT UNION ACCOUNT:</b
            ><br />
            <div class="checkbox">
              <label style="font-weight: normal;">
                <input
                  type="checkbox"
                  [(ngModel)]="auth"
                  name="authorize"
                  value="yes"
                  required="required"
                /><span
                  class="help-block has-error validationMessage"
                  *ngIf="check"
                >
                  Required
                </span>
                I authorize the U.S. Treasury's Financial or Fiscal Agent to
                initiate debit and credit entries to my bank or credit union
                account at the financial institution specified above in order to
                fulfill any requests I may make to transfer funds between my
                bank or credit union account and my Treasury SVC account.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button
        id="enroll_button"
        type="button"
        class="btn btn-block pull-right"
        [disabled]="processing"
        (click)="next()"
      >
        I Agree and Apply
      </button>
    </div>
  </div>
</div>
